const $addBtn = $('.js-add-nominee'),
		$cancelBtn = $('.js-cancel-nominee');

$addBtn.click(toggleForm)
$cancelBtn.click(toggleForm)
	
function toggleForm(){
	let $this = $(this);
	
	$this.parents('.nominee__block').find('.nominee__form').toggle()
}


// WEBPACK FOOTER //
// ./app/src/assets/js/partials/addJurymember.js